import { baseChartMixin } from '@/reusable/base-chart/base-chart-mixin'
import * as apiTo from './api'

export function commonPropertiesMixin(api, customChartData) {
  return {
    mixins: [baseChartMixin],

    created() {
      this.getChartData()
      this.customChartData = customChartData
    },

    methods: {
      getChartData() {
        apiTo.getChartData(api, this.$route.params.id).then(({ data }) => {
          this.chartData = data.result.chart
          this.supportData = data.result.support_data
        })
      }
    }
  }
}
